<template>
          <div class="row">
            <div class="col-12 mb-4">
              <SoftButton @click="goBack()" type="button" color="primary"> 
                <i
                class="fas fa-arrow-left text-sm ms-1"
                aria-hidden="true"
                ></i> &nbsp;&nbsp; Back to Menu
              </SoftButton>
            </div>
            <div class="col-12">
              <div class="card mb-4" style="padding: 15px;">
                <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
                  <div style="min-width: 310px;
                    max-width: 350px; display: flex; align-items: center; gap: 5px;">
                    <b>Team</b>
                    <Multiselect 
                    style="border-radius: 0.5rem; "
                      @change="sendFilter()"
                      v-model="doc_collections.value"
                      v-bind="doc_collections"
                      placeholder="Select a team"
                    ></Multiselect>
                  </div>
                  <soft-button style="display: flex; gap: 5px;" @click="reloadWebs()" color="success" size="md" variant="outline">
                    <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Refresh
                  </soft-button>
                </div>
              </div>
            </div>
            <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> {{ responseMessage }} </strong>
            </soft-alert>
            <soft-alert v-show="webCorrect === true" color="success" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> Web uploaded correctly! </strong>
            </soft-alert>
            <soft-alert v-show="webDeleted === true" color="success" icon="ni ni-unlike-2 ni-lg" dismissible>
              <strong> Web deleted correctly! </strong>
            </soft-alert>
            <div class="col-12">
              <div class="card">
                <div class="card-header pb-0 mb-4">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div style="display: flex;
                      gap: 10px;
                      align-items: baseline;">
                      <h6 style="margin: 0"><span style="color: #cb0c9f;font-weight: 600;">{{K.fNumber(dataWebs.length)}}</span> <span v-if="dataWebs.length !== 1">Webs</span><span v-else>Web</span></h6>
                      
                    </div>
                    <div>
                      <SoftButton data-bs-toggle="modal" data-bs-target="#newWeb" @click="newWeb()">
                        New web
                      </SoftButton>
                    </div>
                  </div>
                </div>
                <div style="height: 400px; display: flex; align-items: center; justify-content: center;" v-if="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </div>
                <div v-else>
                  <div v-show="dataWebs.length !== 0" style="max-height: 720px; overflow-y: scroll; height: 400px; padding: 15px !important;">
                    <div  class="table-responsive" style="min-width: 800px;">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th
                              class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              Title
                            </th>
                            <th
                              class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >
                              Link
                            </th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              Team
                            </th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              State
                            </th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              Last update
                            </th>
                            <th
                              class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >
                              Delete
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in dataWebs" v-bind:key="row">
                            <td style="overflow: hidden;">
                              <div class="d-flex px-2 py-1">
                                <div class="d-flex flex-column justify-content-center">
                                  <h6 v-if="row.title !== null" :title="row.title" class="mb-0 text-sm">{{ row.title }}</h6>
                                  <h6 v-else class="mb-0 text-sm">No title assigned yet</h6>
                                </div>
                              </div>
                            </td>
                            <td style="overflow: hidden;" class="align-middle text-center text-sm">
                              <a :title="row.url" :href="row.url" target="_blank" class="text-xs font-weight-bold">{{ row.url }}</a>
                            </td>
                            <td class="align-middle text-center text-sm">
                              <span class="text-xs font-weight-bold" style="padding: 5px; background-color: #cb0c9f; color: #fff; border-radius: 20px;">
                                {{ Object.values(row.collections).join(', ') }}
                              </span>
                            </td>
                            <td class="align-middle text-center text-sm">
                              <span v-if="row.state === 'done'" class="text-xs font-weight-bold" style="padding: 5px; background-color: #00e476; color: #fff; border-radius: 20px;">
                                Done
                              </span>
                              <span v-else class="text-xs font-weight-bold" style="padding: 5px; background-color: #9e9e9e; color: #fff; border-radius: 20px;">
                                Not extracted yet
                              </span>
                            </td>
                            <td class="align-middle text-center text-sm">
                              <span v-if="row.last_update !== null" class="text-secondary text-xs font-weight-bold">
                                {{ formatDate(row.last_update) }}
                              </span>
                            </td>
                            <td class="align-middle text-center text-sm">
                              <a @click="deleteWeb(row.token, row.title)" data-bs-toggle="modal" data-bs-target="#deleteWeb"
                                class="btn text-secondary font-weight-bold text-xs"
                                data-toggle="tooltip"
                                data-original-title="Delete user">
                                Delete
                              </a>
                            </td>
                          </tr>
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div v-show="dataWebs.length === 0" style="display: grid; justify-items: center; padding: 25px;">
                    <img style="width: 50%;" src="../../assets/img/Static-website-pana.png" /> 
                    <p class="text-2xl text-center sm:text-4xl font-bold text-darkblue-500 mb-2">
                      Ups!... no results found
                    </p>
                    <p class="text-xl text-gray-700">Add a new website to this team</p>
                    <SoftButton data-bs-toggle="modal" data-bs-target="#newWeb" @click="newWeb()">
                      New web
                    </SoftButton>
                  </div>
                </div>
              </div>
            </div>
            
          </div>

          <!-- Modal New Webs-->
          <div class="modal fade" data-bs-backdrop="static" id="newWeb" tabindex="-1" aria-labelledby="newWebLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="teamModalLabel">New web</h5>
                  
                </div>
                <div class="modal-body">
                  <label>Teams</label>
                    <Multiselect
                    style="border-radius: 0.5rem; "
                      v-model="multipleSelect.value"
                      v-bind="multipleSelect"
                      placeholder="Select at least one team"
                    ></Multiselect>
                  <label>Select the type of link</label>
                  <Multiselect
                  style="border-radius: 0.5rem; "
                    v-model="typeOfLink.value"
                    v-bind="typeOfLink"
                    placeholder="Select an option"
                  ></Multiselect>
                  <div v-if="typeOfLink.value === 'url'">
                    <label>Website url</label>
                    <input
                      id="website-url"
                      type="text"
                      class="form-control"
                      v-model="url"
                      placeholder="Paste the website url here"
                    />
                  </div>
                  <div v-if="typeOfLink.value === 'sitemap'">
                    <label>Website sitemap</label>
                    <input
                      id="sitemap-url"
                      type="text"
                      class="form-control"
                      v-model="url"
                      placeholder="Paste the website sitemap here"
                    />
                  </div>
                  
                </div>
                <div class="modal-footer">
                  <SoftButton id="cerrarModal" type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton @click="postWeb()">Save changes</SoftButton>
                </div>
              </div>
              <soft-alert v-show="showResponseNewWeb === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
                <strong> {{ responseNewWeb }} </strong>
              </soft-alert>
              <soft-alert v-show="noBBDDselected === true" color="danger" icon="ni ni-dislike-2 ni-lg" dismissible>
                <strong>Select at least one team</strong>
              </soft-alert>
            </div>
          </div>

          <div class="modal fade" id="deleteWeb" data-bs-backdrop="static" tabindex="-1" aria-labelledby="deleteWebModal" aria-hidden="true">
            <div class="modal-dialog modal-md">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="deleteModal">Delete web</h5>
                  
                </div>
                <div class="modal-body">
                  You are about to delete the web <b>{{ deleteTitle }}</b>, do yo want to proceed?
                </div>
                <div class="modal-footer">
                  <SoftButton type="button" color="secondary" data-bs-dismiss="modal">Close</SoftButton>
                  <SoftButton color="danger" @click="deleteWeb4real()" data-bs-dismiss="modal">Delete</SoftButton>
                </div>
              </div>
            </div>
          </div>
</template>

<script>
  import SoftButton from '../../components/SoftButton.vue';
  import SoftAlert from "@/components/SoftAlert.vue";
  import HTFetch from "../../llamadas/HTFetch"
  import Multiselect from '@vueform/multiselect'
  import K from "../../llamadas/K"


  export default {
    name: "webs",
    
    components: {
      SoftButton,
      SoftAlert,
      Multiselect
    },

    data() {
      return {
        showResponseNewWeb: false,
        responseNewWeb: "",
        loading: false,//true,
        loader: false,
        url: "",
        responseMessage: "",
        showResponseMessage: false,
        dataWebs: [],
        llamada: new HTFetch(),
        K: new K(),
        multipleSelect: {
          mode: 'tags',
          value: [],
          closeOnSelect: false,
          options: [
            { value: 'batman', label: 'Batman' },
            { value: 'robin', label: 'Robin' },
            { value: 'joker', label: 'Joker' },
          ]
        },
        typeOfLink: {
          value: [],
          closeOnSelect: true,
          options: [
            { value: 'sitemap', label: 'Sitemap' },
            { value: 'url', label: 'URL' },
          ],
          canClear: false,
          canDeselect: false
        },
        doc_collections: {
          value: [],
          closeOnSelect: true,
          options: [],
          canClear: false,
          canDeselect: false
        },
        noData: true,
        webCorrect: false,
        webDeleted: false,
        deleteToken: "",
        deleteTitle: "",
        noBBDDselected: false,
        interval: null
      };
    },

    mounted() {
      this.userInformation()
      this.refreshWebs()
    },

    beforeUnmount() {
      // Clear the interval when the component is about to be destroyed
      clearInterval(this.interval);
    },

    computed: {
    },

    methods: {

      refreshWebs() {
        
        this.interval = setInterval(
          () => {
            this.getWebs()
          }, 1000*30
        )
      },

      userInformation() {
        this.llamada.userInfo(this.userInfoRsp.bind(this))
      },

      userInfoRsp(rsp) {
        if (rsp.status === 401) {
          
          this.llamada.userInfo(this.userInfoRsp.bind(this))
          return
        }
        
        let collecciones = []
        for (let i = 0; i < Object.keys(rsp.data.document_collections).length; i++) {
          collecciones.push({
            "label": Object.keys(rsp.data.document_collections)[i],
            "value": Object.values(rsp.data.document_collections)[i]
          })
        }

        localStorage.docCollections = JSON.stringify(collecciones)

        this.multipleSelect.options = collecciones
        this.doc_collections.options = collecciones
        this.doc_collections.value = collecciones[0].value

        localStorage.userId = rsp.data.token
      },

      reloadWebs() {
        this.loading = true
        this.loader = true
        this.getWebs()
      },

      sendFilter() {
        this.dataWebs = []
        this.loading = true
        setTimeout(() => {
          this.getWebs()
        }, 500)
      },

      getWebs() {
        //this.loading = true
        this.llamada.getWebs(this.doc_collections.value, this.getWebsRsp.bind(this))
      },

      getWebsRsp(rsp) {
        // Iterar sobre los emails en rsp.data.emails
        if (this.dataWebs.length !== 0) {
          rsp.data.forEach(webRsp => {
            // Verificar si el token del email actual de rsp.data.emails ya existe en this.datos.emails
            const webExistente = this.dataWebs.find(webDatos => webDatos.token === webRsp.token);

            // Si el email con ese token no existe en this.datos.emails, lo inyectamos
            if (!webExistente) {
              this.dataWebs.push(webRsp);
            }
          });
        } else {
          this.dataWebs = rsp.data
        }

        setTimeout(() => {
          this.loading = false
          this.loader = false
        }, 500)
        
        if (this.dataWebs.length !== 0) {
          this.noData = false
          
        } else {
          this.noData = true
        }
        
        if (rsp.status === 402) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.Message.replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
        } 
      },

      postWeb() {

        if (this.multipleSelect.value.length === 0) {

          this.noBBDDselected = true

          setTimeout(() => {
            this.noBBDDselected = false
          }, 2000)

          return
        }
        
        if (!this.url.includes('https://') && !this.url.includes('http://')) {
          this.url = "https://" + this.url
        }

        let body = {
          "url": this.url,
          "type": this.typeOfLink.value,
          "collection": this.multipleSelect.value
        }

        this.llamada.postWeb(body, this.postWebRsp.bind(this))

        //mando evento
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "send-web",
            user_id: localStorage.userId
          });
        }
      },

      postWebRsp(rsp) {
        this.loading = true
        this.dataWebs = []

        if (rsp.status !== 200) {
          
          if ('type' in rsp.data) {
            this.responseNewWeb = rsp.data.type[0]
          }

          if ('url' in rsp.data) {
            this.responseNewWeb = rsp.data.url[0]
          }

          if ('message' in rsp.data) {
            this.responseNewWeb = rsp.data.message
          }
          
          this.showResponseNewWeb = true

          setTimeout(() => {
            this.showResponseNewWeb = false
          }, 5000)

          return
        } else {
          this.webCorrect = true
          document.getElementById('cerrarModal').click()

          this.multipleSelect.value = []
          this.url = ""

          setTimeout(() => {
            this.webCorrect = false
          }, 2000)
        }

        this.getWebs()

      },

      deleteWeb(token, title) {
        this.deleteTitle = title
        this.deleteToken = token
      },

      deleteWeb4real() {

        let body = {
          "tokens": [this.deleteToken]
        }

        this.llamada.deleteWeb(body, this.deleteWebRsp.bind(this))
      },

      deleteWebRsp(rsp) {
        this.loading = true
        this.dataWebs = []

        if (rsp.status !== 200) {
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('tokens' in rsp.data) {
            this.responseMessage = rsp.data.tokens
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.Message.replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
        } else {
          this.webDeleted = true
          setTimeout(() => {
            this.webDeleted = false
          }, 2000)
        }

        this.getWebs()
      },

      goBack() {
        console.log('el error de volver a Database está aqui')
        this.$emit('go-back')
      },

      newWeb() {
        if (this.$gtm.enabled()) {
          window.dataLayer?.push({
            event: "import-new-web",
            user_id: localStorage.userId
          });
        }
      },

      formatDate(date) {
        const fecha = new Date(date);

        const year = fecha.getFullYear();
        const month = ("0" + (fecha.getMonth() + 1)).slice(-2);
        const day = ("0" + fecha.getDate()).slice(-2);
        const hours = ("0" + fecha.getHours()).slice(-2);
        const minutes = ("0" + fecha.getMinutes()).slice(-2);
        const seconds = ("0" + fecha.getSeconds()).slice(-2);

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
    
  };
</script>

<style scoped>
    .tilting {
        -webkit-animation: fadein 2s infinite;
        animation: fadein 2s infinite;
    }

    @keyframes fadein {
        0% { opacity: 0.25;}
        100% { opacity: 1;}
    }
</style>
